import { Page } from "../../../components/page-base";
import {
  Container,
  DataContainer,
  Filters,
  InfoData,
  StyledFilterButton,
  TopTitle,
} from "./styles";

import { useState } from "react";
import { Dayjs } from "dayjs";
import { CustomDatePicker } from "../components/date-picker";
import { CustomSelect } from "../components/custom-select";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

export const ProfileDashboard = () => {
  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | null>(
    null
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | null>(null);
  const [selectedArea, setSelectedArea] = useState<string>("");
  const [locale, setLocale] = useState<string>("");

  ChartJS.register(
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Filler
  );
  const administrativeAreas = [
    "DF - Distrito Federal",
    "GO - Goiás",
    "SP - São Paulo",
    "RJ - Rio de Janeiro",
  ];

  const filter = () => {};
  const data = {
    labels: [
      "Ativos",
      "Suspensão",
      "Acesso Suspenso",
      "Verificação",
      "Cópia",
      "Gerando Códigos",
      "Fazer Login",
    ],
    datasets: [
      {
        label: "Example Data",
        data: [20, 50, 75, 50, 30, 50, 70, 100, 60, 20, 35, 50],
        fill: true,
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.4,
        pointBackgroundColor: "rgba(0, 0, 255, 1)",
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
  };
  const perfis = {
    ativos: 9602,
    suspensao: 273,
    acessosSuspensos: 2164,
    verificacao: 1069,
    copia: 1185,
    gerandoCodigos: 2,
    fazerLogin: 1,
    total: 14296,
  };

  return (
    <Page.Root>
      <Container id="dashboard-container">
        <Page.HeaderAux />

        <TopTitle>Dashboard de Perfis</TopTitle>
        <DataContainer>
          <Filters>
            <CustomDatePicker
              label="De: (Data da última atualização)"
              value={selectedStartDate}
              onChange={setSelectedStartDate}
            />
            <CustomDatePicker
              label="Até: (Data da última atualização)"
              value={selectedEndDate}
              onChange={setSelectedEndDate}
            />
            <CustomSelect
              label="Área Administrativa:"
              value={selectedArea}
              onChange={(e) => setSelectedArea(e.target.value as string)}
              options={administrativeAreas}
              placeholder="DF, GO, Distrito Federal, Goiás"
            />
            <CustomSelect
              label="Localidade:"
              value={locale}
              onChange={(e) => setLocale(e.target.value as string)}
              options={administrativeAreas}
              placeholder="Brasília, São Paulo, Goiás"
            />
            <StyledFilterButton onClick={filter}>
              <FilterListIcon />
            </StyledFilterButton>
          </Filters>
          <div className="chart-container">
            <Line data={data} options={options} />
          </div>
          <InfoData>
            <div className="line-data">
              <span>Nome </span>
              <span>Índice</span>
            </div>
            <hr />
            <div className="line-data">
              <div>
                <span>Quantidade de perfis - </span>
                <span className="stronger">Ativos </span>
              </div>
              <span>{perfis.ativos}</span>
            </div>
            <hr />
            <div className="line-data">
              <div>
                <span>Quantidade de perfis - </span>
                <span className="stronger">Suspensão </span>
              </div>
              <span>{perfis.suspensao}</span>
            </div>
            <hr />
            <div className="line-data">
              <div>
                <span>Quantidade de perfis - </span>
                <span className="stronger">Acesos Suspensos </span>
              </div>
              <span>{perfis.acessosSuspensos}</span>
            </div>
            <hr />
            <div className="line-data">
              <div>
                <span>Quantidade de perfis - </span>
                <span className="stronger">Verificação </span>
              </div>
              <span>{perfis.verificacao}</span>
            </div>
            <hr />
            <div className="line-data">
              <div>
                <span>Quantidade de perfis - </span>
                <span className="stronger">Cópia </span>
              </div>
              <span>{perfis.copia}</span>
            </div>
            <hr />
            <div className="line-data">
              <div>
                <span>Quantidade de perfis - </span>
                <span className="stronger">Gerando Códigos </span>
              </div>
              <span>{perfis.gerandoCodigos}</span>
            </div>
            <hr />
            <div className="line-data">
              <div>
                <span>Quantidade de perfis - </span>
                <span className="stronger">Fazer Login </span>
              </div>
              <span>{perfis.fazerLogin}</span>
            </div>
            <hr />
            <div className="line-data">
              <span>Total</span>
              <span>{perfis.total}</span>
            </div>
          </InfoData>
        </DataContainer>
      </Container>
    </Page.Root>
  );
};
